import { render } from "./Callback.vue?vue&type=template&id=6b1429ad"
import script from "./Callback.vue?vue&type=script&lang=js"
export * from "./Callback.vue?vue&type=script&lang=js"
script.render = render

export default script